import { Component, OnInit } from '@angular/core';
import {CoreComponent} from '../../core/core.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Results} from '../../core/results';
import {Grade} from './grade/grade';
import {GradesService} from './grades.service';
import {GradeComponent} from './grade/grade.component';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Meta, Title} from '@angular/platform-browser';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
declare var bootbox: any;
@Component({
  selector: 'app-grades',
  templateUrl: './grades.component.html',
  styleUrls: ['./grades.component.scss']
})
export class GradesComponent extends CoreComponent<Grade> {
  @BlockUI() blockUI: NgBlockUI;
  constructor(protected servicesService: GradesService,public meta: Meta, public title: Title,
              public activeModal: NgbActiveModal,
              protected gaService: GoogleAnalyticsService,
              private router: Router,private modalService: NgbModal,public route: ActivatedRoute, private matSnackBar: MatSnackBar) {
    super(servicesService,route);
    this.title.setTitle('Grades');
  }

  public search() {
    this.blockUI.start();
    this.servicesService.search(this.currentPage, this.perPage, this.order, this.orderBy, this.keyword)
      .subscribe((data: Results<Grade>) => {
        this.results = data;
        this.blockUI.stop();
      }, (error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        if (error.status === 401) {
          this.activeModal.close();
          this.router.navigate(['/']);
          this.matSnackBar.open('Your session has expired', 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }else {
          this.blockUI.stop();
          this.matSnackBar.open(error.error.message, 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      });
  }

  remove(item: Grade){
    const that = this;
    bootbox.confirm({
      title: 'Are you sure you want to delete?',
      message: '<strong>'+item.name+'</strong>',
      callback: function(result) {
        if (result === null) {
        } else if (result === true) {
          that.servicesService.delete(item.id).subscribe(()=>{
            that.search();
          }, (error: HttpErrorResponse) => {
            this.blockUI.stop();
            this.gaService.exception(error.error?.message, true);
            if (error.status === 401) {
              this.activeModal.close();
              this.router.navigate(['/']);
              this.matSnackBar.open('Your session has expired', 'Okay', {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            }else {
              this.blockUI.stop();
              this.matSnackBar.open(error.error.message, 'Okay', {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            }
          });
        }
      }
    });
  }

  newItem() {
    this.item = new Grade();
    this.open(this.item);
  }
  open(item: Grade) {
    const modalRef = this.modalService.open(GradeComponent, {fullscreen:true, modalDialogClass:'animate-bottom'});
    modalRef.componentInstance.item= item;
    modalRef.componentInstance.name = 'World';
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }

}
